import react, { useState } from 'react'

export default function useAnswerControls(props) {
    const showControlButtons = () => props.showControlButtons

    // These are expected to be passed as props
    const isSystemUser = () => props.isSystemUser
    const showArchiveConfirm = props.showArchiveConfirm
    const showDeleteConfirm = props.showDeleteConfirm

    const showCopyLink = () => {
        return (
            showControlButtons() &&
            !props.editMode &&
            !isSystemUser() &&
            !showArchiveConfirm &&
            !showDeleteConfirm &&
            !props.systemQuoteNoti
        )
    }

    const showCopyText = () => showCopyLink()

    return {
        showControlButtons,
        showCopyLink,
        showCopyText,
    }
}
